import { render, staticRenderFns } from "./HouseType.vue?vue&type=template&id=01ba72b4&scoped=true"
import script from "./HouseType.vue?vue&type=script&lang=js"
export * from "./HouseType.vue?vue&type=script&lang=js"
import style0 from "./HouseType.vue?vue&type=style&index=0&id=01ba72b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ba72b4",
  null
  
)

export default component.exports